import { Loading } from '@ferreri/prever-component-lib';

import { TelevetAccessIntent } from 'modules/televet/TelevetAccessIntent';
import { TelevetBenefitEmptyState } from 'modules/televet/TelevetBenefitEmptyState';
import { useHasBenefit } from './contract.store';
import { OverdueBenefitUsage } from './OverdueBenefitUsage';

export const VerifyAvailabilityBenefitUsage = () => {
  const query = useHasBenefit();

  if (query?.isLoading) {
    return <Loading />;
  }

  if (query?.data?.allowed_usage) {
    return <TelevetAccessIntent />;
  }

  if (!query?.data?.payment_restriction?.is_valid) {
    return <OverdueBenefitUsage />;
  }

  if (
    !query?.data?.benefit_available_in_contract?.is_valid ||
    !query?.data?.contract_active?.is_valid
  ) {
    return <TelevetBenefitEmptyState />;
  }

  return <Loading />;
};
